<div class="app-tips-feedback-popup p-0" [ngStyle]="{'color': dynamicSettingsData ? dynamicSettingsData?.form_font_secondary_color : '','background-color': dynamicSettingsData?.form_bg_color ? dynamicSettingsData?.form_bg_color :  null, 'font-family': dynamicSettingsData?.font_family ? dynamicSettingsData?.font_family : null  }">
  <!-- Tips start here -->
  <div class="text-center p-20" *ngIf="screenMode=='Tip' || screenMode=='Donation'">
    <div class="fs-25 row no-gutters jc-sb">
      <span class="mt-10">Support Your Creators</span>
      <span class="mt-5"><i class="fa fa-times-circle-o fs-24" (click)="closeDialog()"></i></span>
    </div>
    <hr [ngStyle]="{'background-color':dynamicSettingsData?.form_font_secondary_color}"/>
    <div class="fs-18 text-left pb-10">
      Give a small {{screenMode}} to your favorite artists to help them continue providing world class content for your entertainment.
    </div>
    <div *ngIf="!showPaymentScreen">
      <!-- currency dropdown starts here -->
      <div class="w-100">
        <div class="dropdown app-currency d-inline-block align-self-center w-100" fxShow fxHide.xs="true"
        *ngIf="!router.url.includes('/preview')" [ngStyle]>
        <span class="btn btn-primary btn-primary-mobile-resp dropdown-toggle gt-toggle jc-sb" type="button"
          (click)="clearSearch()" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true"
          aria-expanded="false" [style.background-color]="dynamicSettingsData?.bg_secondary_color + '!important'" [style.color]="dynamicSettingsData?.font_secondary_color +'!important'">
          <span class="d-inline-block w-150p notranslate">
            <span *ngIf="currency?.length <= 4" class="active-color v-bottom">{{ currency }}</span>
            <span *ngIf="currency?.length > 4" class="active-color v-bottom">
              {{ currency | slice: 0:4 }}
              {{currency?.length > 4 ? "" : ""}}
            </span>
          </span>
        </span>
        <div class="dropdown-menu" aria-labelledby="dropdownMenuButton2" [style.background-color]="dynamicSettingsData?.bg_tertiary_color + '!important'" [style.color]="dynamicSettingsData?.font_tertiary_color +'!important'" [ngStyle]="{
          '--scroll-color': dynamicSettingsData?.font_tertiary_color,'--scroll-backcolor':dynamicSettingsData?.bg_tertiary_color}">
          <div class="relative">
            <input type="text" placeholder="Search.." class="search-input" [(ngModel)]="searchCurrency" [style.background-color]="dynamicSettingsData?.bg_tertiary_color + '!important'" [style.color]="dynamicSettingsData?.font_tertiary_color +'!important'">
            <i class="fa fa-search  text-white d-search" aria-hidden="true" [style.color]="dynamicSettingsData?.font_tertiary_color +'!important'"></i>
          </div>
          <div class="dropdown-div" [ngStyle]="{'--hover-bg': dynamicSettingsData?.bg_secondary_color,
          '--hover-color': dynamicSettingsData?.font_secondary_color}">
            <span *ngFor="let currency of currencyJSON | filter: searchCurrency:'currency';let i=index"
            class="notranslate">
              <a class="dropdown-item fs-13"
              (click)="changeCurrency(currency.currency)">{{currency.currency}}
              </a>
            </span>
          </div>
        </div>
      </div>
      </div>
      <!-- Currency dropdown ends here -->
      <div class="fs-16 mt-10 text-left">Enter your {{screenMode}} amount* :</div>
      <div class="w-100 pt-10 pb-10">
        <div class="h-searchbox mr-3 text-right relative d-inline-block">
          <label class="currency-sym-tip" [style.color]="dynamicSettingsData?.font_secondary_color +'!important'">{{ currency|currencySymbol }}</label>
          <input allowValues isInputType="decimalWithTwoDigits" class="h-search w-100" [(ngModel)]="enteredTipAmount" placeholder="Enter your amount" (input)="tipAmountEntered($event)" (blur)="amountChange($event.target.value)"
          [style.background-color]="dynamicSettingsData?.bg_secondary_color + '!important'" [style.color]="dynamicSettingsData?.font_secondary_color +'!important'">
        </div>
      </div>
      <span>Minimum required amount is <span class="price d-inline-block">{{conversionRate | currency : currency}}</span></span>
      <div *ngIf="tipsAmountsList.length>0">
        <div class="fs-16 text-left mt-10">Select a {{screenMode}} amount</div>
        <div class="row no-gutters w-100 mt-10">
          <div *ngFor="let amount of tipsAmountsList" class="col-4">
            <button class="tips-flat-button" [ngClass]="{'tips-primary-button': amount.selected, 'tips-flat-button': !amount.selected}" (click)="onSelectTipAmount(amount)">
              {{(amount.value)*this.conversionRate  | currency: currency}}
            </button>
          </div>
        </div>
      </div>
      <div class="mt-10">
        <span matTooltipPosition="above" [matTooltip]="tipsAmountsList.length > 0 ? 'Select or enter amount to continue' : 'Enter amount to continue'"
        [matTooltipDisabled]="enteredTipAmount">
        <button mat-flat-button class="mb-20" [disabled]="!enteredTipAmount"
        (click)="proceedToPaymentScreen()" [ngStyle]="{'background-color':dynamicSettingsData?.bg_primary_color,'color':dynamicSettingsData?.font_primary_color}">
          Continue
        </button>
        </span>
      </div>
      <div class="skip-button pointer" (click)="goToPollsScreen()"
      matTooltip="Can't skip if an amount is selected"
      [matTooltipDisabled]="!enteredTipAmount" [ngStyle]="{'color':dynamicSettingsData?.font_primary_color}">
        <span *ngIf="this.pollsQuestionsList.length>0">Skip</span>
        <span *ngIf="this.pollsQuestionsList.length==0 || !this.pollsQuestionsList">Close</span> 
      </div>
    </div>
    <!-- Payment screen starts here -->
    <div [hidden]="!showPaymentScreen" class="text-left">
      <div fxLayout="row wrap">
        <div fxFlex="100%" class="mb-5 fw-600 mt-20">Summary</div>
        <div fxLayoutAlign="start center" fxFlex="50%">Items
            <!-- <span *ngIf="incl" style="font-size: 12px;margin-left: 5px;margin-top: 5px;"> (Incl. VAT)</span> -->
        </div>
        <div fxLayoutAlign="end center" fxFlex="50%">
            {{enteredTipAmount | currency:currency}}</div>
        
        <!-- <div fxLayoutAlign="start center" fxFlex="50%" *ngIf="processingFee && (!selectedTransaction || selectedTransaction =='ott')">Processing Fee
        </div> -->
        <div fxLayoutAlign="start center" fxFlex="50%" *ngIf="processingFee && selectedTransaction =='ott'">Processing Fee
        </div>
        <div fxLayoutAlign="end center" fxFlex="50%" *ngIf="processingFee && selectedTransaction =='ott'">
            {{processingFee | currency:currency}}
        </div>
        <div fxLayoutAlign="start center" fxFlex="25%" class="mt-10 pt-10 fs-20 hr-row" [ngStyle]="{'--border-color': dynamicSettingsData?.form_font_secondary_color}">Total</div>
        <div fxLayoutAlign="end center" fxFlex="75%" class="amount notranslate mt-10 pt-10 fs-20 hr-row" [ngStyle]="{'--border-color': dynamicSettingsData?.form_font_secondary_color}">
            {{finalAmount | currency:currency}} <span *ngIf="selectedTransaction== 'crypto'" matTooltip="{{crypto_amount}}">( <img width="20" class="mb-1 mr-1" src="{{cryptoSymbol}}"/>{{ sliced_crypto_amount }}... {{cryptoToken}})</span></div>
        </div>
      <app-payment-transactions (getTransactionDetails)="calFee($event)" [activeBlock]="activeBlock" [settingsData]="dynamicSettingsData"></app-payment-transactions>
    </div>
    <!-- Payment screen ends here -->
  </div>
  <!-- Tips end here -->
  <!-- Polls start here -->
  <div *ngIf="screenMode=='Poll'" class="p-20">
    <div class="fs-25 w-100 row no-gutters jc-sb">
      <span class="mt-10">Share your feedback</span>
      <span class="mt-5"><i class="fa fa-times-circle-o fs-24" (click)="closeDialog()"></i></span>
    </div>
    <hr [ngStyle]="{'background-color':dynamicSettingsData?.form_font_secondary_color}" />
    <div class="fs-20 text-left" *ngIf="streamInfo && streamInfo.poll_title && audio_video!='video'">{{streamInfo.poll_title}}</div>
    <div class="fs-20 text-left" *ngIf="audio_video=='video'">{{video_poll_title}}</div>
    <div class="mt-10 mt-20" *ngIf="pollsQuestionsList.length>=pollsQuestionIndex+1">
      <div class="mb-10">Question {{pollsQuestionIndex+1}} out of {{pollsQuestionsList.length}}</div>
      <div class="mb-10"><mat-progress-bar mode="determinate" [value]=pollsProgressBar></mat-progress-bar></div>
    </div>
    <div *ngIf="pollsQuestionsList.length>0 && pollsQuestionsList.length>=pollsQuestionIndex+1">
      <div class="fs-18 mb-10 mt-20">
        Q. {{pollsQuestionsList[pollsQuestionIndex]['question']}}
      </div>
      <div *ngFor="let option of pollsQuestionsList[pollsQuestionIndex]['options']" (click)="selectPollsOption(pollsQuestionIndex,option)">
        <button class="polls-flat-button" [ngClass]="{'polls-primary-button': option.selected, 'polls-flat-button': !option.selected}"
        [ngStyle]="{'--button-bg':dynamicSettingsData?.bg_tertiary_color,'--button-color':dynamicSettingsData?.font_tertiary_color,'--hover-bg': dynamicSettingsData?.bg_secondary_color,
        '--hover-color': dynamicSettingsData?.font_secondary_color}">
          <span *ngIf="option.option && option.option.length <= 30">
            {{option.option}}
          </span>
          <span *ngIf="option.option && option.option.length >30"
            matTooltipPosition="above" matTooltip="{{option.option}}">
            {{option.option | slice: 0:25}}
            {{option.option.length > 25 ? "..." : ""}}
          </span>
        </button>
      </div>
    </div>
    <div *ngIf="pollsQuestionsList.length>pollsQuestionIndex+1" class="text-center mt-20">
      <span matTooltipPosition="above" 
      matTooltip="Select one option to continue"
      [matTooltipDisabled]="shareFeedbackContinueButton">
      <button mat-flat-button  (click)="goToNextQuestion()" [disabled]="!shareFeedbackContinueButton"
      [ngStyle]="{'background-color':dynamicSettingsData?.bg_primary_color,'color':dynamicSettingsData?.font_primary_color}">
        Continue
      </button>
      </span>
    </div>
    <div *ngIf="pollsQuestionsList.length==pollsQuestionIndex+1" class="text-center mt-20">
      <button mat-flat-button  (click)="goToNextQuestion()" [disabled]="!shareFeedbackContinueButton" [ngStyle]="{'background-color':dynamicSettingsData?.bg_primary_color,'color':dynamicSettingsData?.font_primary_color}">
        Submit
      </button>
    </div>
    <div class="skip-button pointer mt-20 text-center" (click)="goToPollsScreen()" *ngIf="pollsQuestionIndex==0 && pollsQuestionsList.length>1" (click)="closeDialog()" [ngStyle]="{'color':dynamicSettingsData?.font_primary_color}">
      Skip
    </div>
    <div class="skip-button pointer mt-20 text-center" (click)="goToPollsScreen()" *ngIf="pollsQuestionIndex==0 && pollsQuestionsList.length==1" (click)="closeDialog()" [ngStyle]="{'color':dynamicSettingsData?.font_primary_color}">
      Close
    </div>
    <!-- End card starts here -->
    <div *ngIf="pollsQuestionsList.length<pollsQuestionIndex+1 && submittedPollsSuccessfully">
      <div class="fs-18 mt-10 mb-10">
        Thanks for your participation. 
        <span *ngIf="pollsSubmittedResultData.length>0">Checkout the results.</span>
      </div>
      <div>
        <div *ngFor="let question of pollsSubmittedResultData">
          <div class="submit-question row no-gutters pointer" (click)="expandQuestion(question)">
            <span class="col-10">Q. {{question.question}}</span>
            <span class="col-2 text-right" style="align-self: center;">
              <i class="fa fa-chevron-down fs-20" *ngIf="!question.expanded"></i>
              <i class="fa fa-chevron-up fs-20" *ngIf="question.expanded"></i>
            </span>
          </div>
          <div class="text-center w-100">
            <div class="submit-answer" *ngIf="question.expanded">
              <div *ngFor="let options of question.options;let i=index" class="mt-10 mb-10" >
                <div class="base-color-div">
                  &nbsp;
                  <div class="poll-percent-color-div" [ngStyle]="{width:pollsSubmittedResultData[0]['results'][i]+'%'}">&nbsp;</div>
                  <div class="poll-percent-text-div">
                    <div>
                      <span *ngIf="options.option && options.option.length <= 30">
                        {{options.option}}
                      </span>
                      <span *ngIf="options.option && options.option.length >30"
                        matTooltipPosition="above" matTooltip="{{options.option}}">
                        {{options.option | slice: 0:25}}
                        {{options.option.length > 25 ? "..." : ""}}
                      </span>
                    </div>
                    <div *ngIf="pollsSubmittedResultData[0] && pollsSubmittedResultData[0]['results']">
                      {{pollsSubmittedResultData[0]['results'][i]}} %
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mb-20 mt-20 text-center">
        <button type="button" mat-flat-button class="flat-secondary-button" (click)="closeDialog()">
        Close 
        </button>
      </div>
    </div>
    <!-- End card ends here -->
  </div>
  <!-- Polls end here -->
</div>
